<script lang="ts">
	import { format } from 'svelte-i18n';
	import type { Device } from 'src/types/Device';
	import type { ViewVariant } from 'src/types/DeviceUI';
	import {
		sidepanelViewSelection,
		sidepanelViewSwitcherAvailable,
		setSidepanelViewSelection,
	} from 'src/stores/features/dev/sidepanel-view-switcher';
	import { Container, SelectV2, ToggleV2 } from '@Shelly/shelly-design-system';
	import { getAvailableViews, getCurrentView } from 'src/components/Sidepanel/view-helpers';

	export let device: Device | undefined;

	$: views = device ? getAvailableViews(device) : [];
	$: current = device
		? getCurrentView(device, {
				switcherEnabled: $sidepanelViewSwitcherAvailable,
				selected: $sidepanelViewSelection[device?.id],
			})
		: undefined;
	$: showSwitcher = Boolean(device && $sidepanelViewSwitcherAvailable && views.length > 1);
	$: selectOptions = views.map((view) => view.title);
	$: selectedOption =
		views.find((view) => view.variant === current?.variant)?.title ?? selectOptions[0];
	$: controlId = `sidepanel-main-view-${String(device?.id ?? 'device').replace(/[^a-zA-Z0-9_-]/g, '-')}`;

	const onSelectVariant = (variant: ViewVariant) => {
		if (!device?.id) return;
		setSidepanelViewSelection(device.id, variant);
	};
</script>

{#if showSwitcher}
	<div class="sidepanel-view-switcher">
		<Container type="borderSolid" backgroundColor="color-base" padding="xs" noScroll>
			{#if views.length === 2}
				<ToggleV2
					id={controlId}
					size="m"
					checked={current?.variant === views[1].variant}
					aria-label={$format('label_dev_sidepanel_view', { default: 'Dev view' })}
					on:click={() =>
						onSelectVariant(
							current?.variant === views[1].variant ? views[0].variant : views[1].variant,
						)}
				/>
			{:else}
				<SelectV2
					id={controlId}
					icon={null}
					size="m"
					width="full"
					aria-label={$format('label_dev_sidepanel_view', { default: 'Dev view' })}
					options={selectOptions}
					value={selectedOption}
					on:change={(e) => {
						const title = typeof e.detail === 'string' ? e.detail : e.detail?.title;
						const match = views.find((view) => view.title === title);
						if (match) onSelectVariant(match.variant);
					}}
				/>
			{/if}
		</Container>
	</div>
{/if}

<style>
	.sidepanel-view-switcher {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 2;
		pointer-events: auto;
	}
</style>
